const HoverTooltip = props => {
    return (
        <div
        id="hover-tooltip"
        className="hover-tooltip"
        //style={{ borderRadius: 10 }}
      >
        <p></p>
      </div>
    )
}

export default HoverTooltip